import React from "react";
import { IAppState } from "../state/interfaces";
import { IVehicleStepProps, IDriverStepProps } from "../components/interfaces";
import { IQuoteStepComponentProps, IQuoteStepState } from "../components/interfaces";
import { COMPONENTS, RELOAD_PATH } from "../AppConstants";
import { validationUtils } from "../validation/Validation";

class QuoteStepBase<P extends IQuoteStepComponentProps, S extends IQuoteStepState> extends React.Component<P, S> {
    constructor(props: P) {
        super(props);
    }

    componentDidMount() {
        //this.props.reportCurrentStep();
        this.subscribeToValidation();
    }   

    componentWillUnmount() {
        this.unsubscribeFromValidation();
    }

    subscribeToValidation() {
        validationUtils.subscribeToValidationFailure(this.props.id,
            validationData => {
                this.setState({ ...this.state, updatingStore: false, errors: validationData });
            });
    }

    unsubscribeFromValidation() {
        validationUtils.unsubscribeFromValidationFailure(this.props.id);
    }

    setStateValue(value: any, property: string, stateObj?: any | null) {
        const obj = stateObj ? stateObj : {};
        obj[property] = value;
        this.setState({ ...this.state, ...obj });
    }

    getValueSafe(obj: any, property: string) {
        return obj ? obj[property] : "";
    }

    reloadComponent(url: string) {
        this.props.history.replace(RELOAD_PATH);
        this.props.history.replace(url);
    }

    static canMergeAppState<P extends IQuoteStepComponentProps, S extends IQuoteStepState>(props : P, state: S) {
        return (props.meta.propsSource === COMPONENTS.PROPS_SOURCES.APP_STORE && !state.appStateMerged);
    }
}

export default QuoteStepBase

export const mapStepPropsBase = (state: IAppState) => {
    return {
        quoteUid: state.quoteUid,
        meta: { propsSource: COMPONENTS.PROPS_SOURCES.APP_STORE }
    };
};

export const mapVehicleStepProps = (state: IAppState, ownProps: IVehicleStepProps) => {
    var vehicleIndex = !ownProps.match.params["vehicleIndex"]
        ? 0
        : parseInt(ownProps.match.params["vehicleIndex"], 10);

    return {
        quoteUid: state.quoteUid,
        vehicleIndex: vehicleIndex,
        vehicle: vehicleIndex < state.vehicles.length ? state.vehicles[vehicleIndex] : null,
        meta: { propsSource: COMPONENTS.PROPS_SOURCES.APP_STORE },
        vehiclesCount: state.vehicles.length
    };
};

export const mapDriverStepProps = (state: IAppState, ownProps: IDriverStepProps) => {
    var driverIndex = !ownProps.match.params["driverIndex"]
        ? 0
        : parseInt(ownProps.match.params["driverIndex"], 10);

    return {
        quoteUid: state.quoteUid,
        driverIndex: driverIndex,
        driversCount: state.drivers.length,
        driver: driverIndex < state.drivers.length ? state.drivers[driverIndex] : null,
        insured: driverIndex > 0 ? state.drivers[0] : null,
        secondDriver: state.drivers.length >= 2 && driverIndex == 0 ? state.drivers[1] : null,
        meta: { propsSource: COMPONENTS.PROPS_SOURCES.APP_STORE }
    };
};

export const mapInsuranceStepProps = (state: IAppState) => {
    return {
        quoteUid: state.quoteUid,
        currentInsurance: state.currentInsurance,
        meta: { propsSource: COMPONENTS.PROPS_SOURCES.APP_STORE },
        stateCode: state.stateCode
    };
};